import React from 'react';
import { Button } from '../../ui/Button';
import { Input } from '../../ui/Input';
interface AddressScreenProps {
  address: string;
  city: string;
  zipCode: string;
  onChange: (field: string, value: string) => void;
  onNext: () => void;
  onBack: () => void;
}
export function AddressScreen({
  address,
  city,
  zipCode,
  onChange,
  onNext,
  onBack
}: AddressScreenProps) {
  const isValid = address.trim().length > 0 && city.trim().length > 0 && zipCode.trim().length > 0;
  return <div className="flex flex-col h-full max-w-md mx-auto pt-8 animate-in fade-in slide-in-from-bottom-4 duration-500" data-id="element-55">
      <div className="flex-1" data-id="element-56">
        <h2 className="text-2xl font-semibold text-gray-900 mb-2" data-id="element-57">
          Where do you live?
        </h2>
        <p className="text-gray-500 mb-8" data-id="element-58">
          We need your current residential address for verification.
        </p>

        <div className="space-y-6" data-id="element-59">
          <Input label="Street Address" placeholder="e.g. 123 Main St, Apt 4B" value={address} onChange={e => onChange('address', e.target.value)} autoFocus data-id="element-60" />
          <div className="grid grid-cols-2 gap-4" data-id="element-61">
            <Input label="City" placeholder="e.g. New York" value={city} onChange={e => onChange('city', e.target.value)} data-id="element-62" />
            <Input label="Zip Code" placeholder="e.g. 10001" value={zipCode} onChange={e => onChange('zipCode', e.target.value)} data-id="element-63" />
          </div>
        </div>
      </div>

      <div className="flex gap-4 mt-8 pb-8" data-id="element-64">
        <Button variant="secondary" onClick={onBack} className="w-1/3" data-id="element-65">
          Back
        </Button>
        <Button variant="primary" onClick={onNext} disabled={!isValid} className="w-2/3" data-id="element-66">
          Continue
        </Button>
      </div>
    </div>;
}